import * as Sentry from '@sentry/react';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
// import i18n (needs to be bundled)
import './i18n';
// Import Global Styles
import '@/assets/css/style.css';
import '@/assets/css/tailwind.css';
import '@/assets/scss/style.scss';
import '@/assets/styles/index.scss';
import { env } from '@/env';
import { router } from '@/routes/';

const root = createRoot(document.getElementById('root') as Element);

const isSetupReady: any = Promise.resolve();

// if (import.meta.env.VITE_NODE_ENV === "development") {
//   // Setup mock api using service worker
//   const url = import.meta.env.VITE_GRAPH_API_URL;
//   isSetupReady = import("./mocks/browser")
//     .then(({ worker }) => worker(url).start({ onUnhandledRequest: "bypass" }))
//     .then(() => console.warn("worker started"));
// }

if (env.VITE_NODE_ENV != 'development') {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    integrations: [
      new Sentry.BrowserTracing({
        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
          'localhost',
          /^\//,
          /agrantis.com\//,
          /agrantis.dev\//,
        ],
      }),
      new Sentry.Replay(),
    ],
    tracesSampleRate: 1.0, // capture 100% of transactions for performance monitoring. We recommend adjusting this value in production
    replaysSessionSampleRate: 0.1, // Capture Replay for 10% of all sessions,
    replaysOnErrorSampleRate: 1.0, // plus for 100% of sessions with an error
  });
}

isSetupReady.then(() => {
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <RouterProvider router={router} />
      </HelmetProvider>
    </React.StrictMode>,
  );
});
// If you want to enable client cache, register instead.
serviceWorker.unregister();
